/* Noir & Lin — size guide: IN/CM switch, selected-size highlight, tap a row to pick that size */
(function () {
  var guides = Array.prototype.slice.call(document.querySelectorAll('[data-size-guide]'));
  if (!guides.length) return;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var KEY = 'nl-size-unit';
  var unit = null;
  try { unit = localStorage.getItem(KEY); } catch (err) {}

  function sizeFieldset() { return document.querySelector('[data-size-option]'); }
  function currentSize() {
    var fs = sizeFieldset();
    var c = fs && fs.querySelector('input:checked');
    return c ? c.value : '';
  }
  function convert(raw, from, to) {
    if (from === to) return raw;
    return raw.replace(/\d+(?:\.\d+)?/g, function (m) {
      var v = parseFloat(m);
      return to === 'cm' ? String(Math.round(v * 2.54)) : String(Math.round((v / 2.54) * 2) / 2);
    });
  }
  function applyUnit(g, u) {
    var base = g.getAttribute('data-base-unit') || 'in';
    $$('[data-sg-val]', g).forEach(function (td) { td.textContent = convert(td.getAttribute('data-sg-val'), base, u); });
    $$('[data-sg-unit]', g).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sg-unit') === u ? 'true' : 'false'); });
    $$('[data-sg-unit-label]', g).forEach(function (l) { l.textContent = u === 'cm' ? 'centimetres' : 'inches'; });
  }
  function sync() {
    var s = (currentSize() || '').toLowerCase();
    guides.forEach(function (g) {
      $$('tr[data-sg-size]', g).forEach(function (tr) {
        var on = !!s && tr.getAttribute('data-sg-size').toLowerCase() === s;
        tr.classList.toggle('is-selected', on);
        tr.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    });
    $$('[data-sg-current]').forEach(function (el) { el.textContent = currentSize() || '—'; });
  }
  function note(g, msg) {
    var n = g.querySelector('.sg__note');
    if (!n) return;
    if (!n._orig) n._orig = n.innerHTML;
    n.textContent = msg;
    clearTimeout(n._t);
    n._t = setTimeout(function () { n.innerHTML = n._orig; }, 2600);
  }
  function unavailableNote(g, tr, size) {
    // More visible than the tiny auto-hiding caption used for other messages:
    // flash the row itself and hold a stronger alert message near the table
    // for longer, so tapping an unavailable size doesn't look like nothing happened.
    if (tr) {
      tr.classList.add('sg__row-flash');
      setTimeout(function () { tr.classList.remove('sg__row-flash'); }, 900);
    }
    var n = g.querySelector('.sg__note');
    if (!n) return;
    if (!n._orig) n._orig = n.innerHTML;
    n.classList.add('sg__note--alert');
    n.textContent = size + ' isn’t offered in this style — see the rows marked “Not offered in this style” above.';
    clearTimeout(n._t);
    n._t = setTimeout(function () {
      n.innerHTML = n._orig;
      n.classList.remove('sg__note--alert');
    }, 4200);
  }
  function selectSize(g, size, tr) {
    if (tr && tr.hasAttribute('data-sg-unavailable')) {
      unavailableNote(g, tr, size);
      return;
    }
    var fs = sizeFieldset();
    if (!fs) return;
    var inp = $$('input', fs).filter(function (i) { return i.value.toLowerCase() === size.toLowerCase(); })[0];
    if (!inp) { note(g, size + ' isn’t offered in this style.'); return; }
    if (inp.disabled) { note(g, size + ' is sold out in this colour.'); return; }
    inp.checked = true;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
    sync();
  }

  guides.forEach(function (g) {
    if (unit) applyUnit(g, unit);
    g.addEventListener('click', function (e) {
      var ub = e.target.closest('[data-sg-unit]');
      if (ub) {
        unit = ub.getAttribute('data-sg-unit');
        try { localStorage.setItem(KEY, unit); } catch (err) {}
        guides.forEach(function (x) { applyUnit(x, unit); });
        return;
      }
      var tr = e.target.closest('tr[data-sg-size]');
      if (tr) selectSize(g, tr.getAttribute('data-sg-size'), tr);
    });
    g.addEventListener('keydown', function (e) {
      var tr = e.target.closest && e.target.closest('tr[data-sg-size]');
      if (tr && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); selectSize(g, tr.getAttribute('data-sg-size'), tr); }
    });
  });
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('[data-size-option]')) sync(); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-drawer-open="SizeDrawer"]')) setTimeout(sync, 0); });
  sync();
})();
